var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.951,
    height: 30,
    viewBox: "0 0 29.951 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.876 7.7a15.047 15.047 0 0 1 7.9-6.8v1.2a13.939 13.939 0 0 0 .7 26 14.351 14.351 0 0 0 4.6.8 13.708 13.708 0 0 0 13-9.2 13.979 13.979 0 0 0-7.9-17.5V.9a14.854 14.854 0 0 1 9.2 10 15.069 15.069 0 0 1-1.3 11.4 14.884 14.884 0 0 1-9 7.1 14.533 14.533 0 0 1-4.1.6 15.027 15.027 0 0 1-13.1-22.3zm12.6-7.7v8.9h1.1V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.f565b3974c269cdef799c2f6e7c044b4.svg";
export { ForwardRef as ReactComponent };